import { Component } from "react";
import { Link, Redirect, withRouter } from 'react-router-dom';
import AppContext from '../../contexts/AppContext'

import "./style.scss";

import { ReactComponent as ArrowDown } from '../assets/icons/arrow-down-ic.svg';

import h from "../assets/icons/h-ic.svg";
import cart from "../assets/icons/cart-ic.svg";
import logo from "../assets/images/logo.svg";
import SettingsSelect from "../SettingsSelect";

class Header extends Component {

    static contextType = AppContext;

    userSettingsToggle=(e)=>{
        this.context.setShowUserSettings(!this.context.showUserSettings);
        e.stopPropagation();
    }

    closeUserSettings=(e)=>{
        this.context.setShowUserSettings(false);
    }

    componentDidMount(){
        window.addEventListener("click", this.closeUserSettings);
    }

    componentWillUnmount(){
        window.removeEventListener("click", this.closeUserSettings);
    }

    componentDidUpdate = () => {
        let url = this.props.location.pathname;
        if (url !== this.url) {
            this.url = url;
            if (this.context.showUserSettings) this.context.setShowUserSettings(false);
        }
    }

    render() {
        const { user } = this.context;

        if (this.user && !user) {
            this.user = null;
            return <Redirect to="/" />
        }

        this.user = user;

        return (
            <header>
                <Link to="/">
                    <img className="logo" alt="Handreytten" src={logo} />
                </Link>
                <nav>
                    {
                        user ?
                            <>
                                <div className="account">
                                    <div className={`user-select ${this.context.showUserSettings ? "show" : ""}`} ref={el => (this.userSelect = el)}>
                                        <div className="label" onClick={this.userSettingsToggle}>
                                            <span>{user.name}</span>
                                            <ArrowDown />
                                        </div>
                                        <SettingsSelect onClick={(e)=>e.stopPropagation()} />
                                    </div>
                                    <img className="user-image" alt="My Account" src={h} />
                                </div>
                                <div className="cart">
                                    <Link to="/my-basket">
                                        <img alt="Cart" src={cart} />
                                        <span>99</span>
                                    </Link>
                                </div>
                                <div className={`hamburguer-filter ${this.context.showUserSettings ? "active" : ""}`} onClick={this.userSettingsToggle}>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </>
                            :
                            (this.context.page.id === "signin" ? <Link className="uh signin" to="/signup">Sign Up</Link> : <Link className="uh signin" to="/signin">Sign In</Link>)
                    }
                </nav>
            </header>
        )
    }
}

export default withRouter(Header);